import { useState } from 'react';
import { addDays, todayIn } from '@njpos/core';
import { api, dayLabel } from '../lib/api';
import { ErrorNote, useLoad } from '../components/ui';

const weekday = (d: string) => new Date(`${d}T12:00:00Z`).toLocaleString('en-US', { weekday: 'long', timeZone: 'UTC' });
const clock = (t: string) => { const [h, m] = t.split(':').map(Number); return `${((h! + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h! < 12 ? 'am' : 'pm'}`; };

// Who works when, a week at a time. Shailesh AI reads it to answer "what time is Casey coming in?".
export default function Schedule() {
  const [from, setFrom] = useState(todayIn());
  const to = addDays(from, 6);
  const data = useLoad(() => api<{ shifts: any[]; people: any[] }>(`/api/schedule?from=${from}&to=${to}`), [from]);
  const [form, setForm] = useState({ userId: '', date: from, start: '09:00', end: '17:00', note: '' });
  const [err, setErr] = useState<unknown>(null);
  const days = Array.from({ length: 7 }, (_, i) => addDays(from, i));

  async function add(e: React.FormEvent) {
    e.preventDefault(); setErr(null);
    try { await api('/api/schedule', { body: { ...form, note: form.note || null } }); setForm({ ...form, note: '' }); data.reload(); } catch (x) { setErr(x); }
  }
  async function remove(id: string) {
    setErr(null);
    try { await api(`/api/schedule/${id}`, { method: 'DELETE' }); data.reload(); } catch (x) { setErr(x); }
  }

  return (
    <div className="stack">
      <div className="page-head">
        <div className="grow"><h1>Staff schedule</h1><p>Plan who works when. Shailesh AI uses this to answer questions like "who is working Saturday?".</p></div>
        <button onClick={() => setFrom(addDays(from, -7))}>Previous week</button>
        <label>Week from<input type="date" value={from} onChange={(e) => e.target.value && setFrom(e.target.value)} /></label>
        <button onClick={() => setFrom(addDays(from, 7))}>Next week</button>
      </div>
      <ErrorNote error={data.error ?? err} />
      <form className="panel" onSubmit={add} style={{ padding: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <label>Person<select required value={form.userId} onChange={(e) => setForm({ ...form, userId: e.target.value })}>
          <option value="">Choose…</option>{data.data?.people.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select></label>
        <label>Day<input type="date" required value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></label>
        <label>Starts<input type="time" required value={form.start} onChange={(e) => setForm({ ...form, start: e.target.value })} /></label>
        <label>Ends<input type="time" required value={form.end} onChange={(e) => setForm({ ...form, end: e.target.value })} /></label>
        <label className="grow">Note<input value={form.note} maxLength={200} placeholder="Optional" onChange={(e) => setForm({ ...form, note: e.target.value })} /></label>
        <button className="primary">Add shift</button>
      </form>
      {days.map((d) => {
        const shifts = data.data?.shifts.filter((s) => s.shift_date === d) ?? [];
        return (
          <div className="panel" key={d}>
            <div className="panel-head"><h2>{weekday(d)}, {dayLabel(d)}</h2></div>
            {shifts.length === 0 ? <div className="empty">Nobody scheduled.</div> : (
              <table className="grid"><tbody>{shifts.map((s) => (
                <tr key={s.id}><td>{s.name}</td><td>{clock(s.start_time)} to {clock(s.end_time)}{s.end_time < s.start_time ? ' (next day)' : ''}</td><td className="faint">{s.note}</td>
                  <td className="n"><button className="ghost" onClick={() => remove(s.id)}>Remove</button></td></tr>
              ))}</tbody></table>
            )}
          </div>
        );
      })}
    </div>
  );
}
